'use client';

import { Typography } from '@mui/material';
import { STATES_MAP } from '@repo/supergraph/marketplace/constants';
import { useGeo } from '../GeoTargeting/GeoProvider';

export function PaidRoundupEyebrow({ isGeoTargeted }: { isGeoTargeted?: boolean }) {
  const { isReady, regionCode } = useGeo();

  let disclosureText = 'ADVERTISEMENT: PRODUCTS FROM OUR PARTNERS';
  if (isGeoTargeted && isReady && regionCode) {
    const stateName = STATES_MAP[regionCode];
    if (stateName) {
      disclosureText += ` - ${stateName.toUpperCase()}`;
    }
  }

  return (
    <Typography
      variant="textBold"
      sx={{ fontSize: '14px', fontWeight: 600, color: 'neutral.darker' }}
    >
      {disclosureText}
    </Typography>
  );
}
